import * as ActionTypes from 'app/common/constants/action-types';
import {
  suggestStarted,
  suggestFailed,
  suggestSuccess,
} from 'app/common/helpers/suggestions';

export const INITIAL_STATE = {};

function dealSuggestionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.DEALS_SUGGEST_REQUEST:
      return suggestStarted(state, action);
    case ActionTypes.DEALS_SUGGEST_FAILURE:
      return suggestFailed(state, action);
    case ActionTypes.DEALS_SUGGEST_SUCCESS:
      return suggestSuccess(state, action);
    default:
      return state;
  }
}

export default dealSuggestionsReducer;
